import { render, staticRenderFns } from "./BookmarkedVideos.vue?vue&type=template&id=6a024140"
import script from "./BookmarkedVideos.vue?vue&type=script&lang=js"
export * from "./BookmarkedVideos.vue?vue&type=script&lang=js"
import style0 from "./BookmarkedVideos.vue?vue&type=style&index=0&id=6a024140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports